<template>
  <div>
    <div>
      <CCardGroup>
        <CCol>
          <CCard class="card__custom">
            <CCardBody>
              <div class="d-flex flex-wrap justify-content-between">
                <div class="col-5 col-md-6 form-group">
                  <label class="mb-1">Nombre del asegurado</label>
                  <input
                    type="text"
                    name="pNom_Solicitante"
                    class="form-control"
                    placeholder="Buscar nombre del asegurado..."
                    @blur="fillSearchFields($event, 'string')"
                  />
                </div>
                <div class="col-lg-3 col-md-6 form-group">
                  <label for="">No. Póliza</label>
                  <input
                    type="number"
                    min="0"
                    class="form-control"
                    placeholder="Buscar póliza..."
                    name="numeroPoliza"
                    @keyup="fillSearchFields"
                  />
                </div>
                <div class="col-lg-3 col-md-6 form-group">
                  <label class="mb-1">Inicio de vigencia</label>
                  <input
                    type="date"
                    name="fechaIni"
                    class="form-control"
                    @blur="fillSearchFields($event, 'date')"
                  />
                </div>
                <div class="col-12 d-flex justify-content-end mt-3">
                  <button class="btn btn-primary" @click="search">
                    Buscar
                  </button>
                </div>
              </div>
            </CCardBody>
          </CCard>
        </CCol>
      </CCardGroup>
    </div>

    <CCardGroup>
      <CCol>
        <CCard class="card__custom">
          <CCardHeader>
            <div class="table-responsive">
              <CDataTable
                :language="{
                  lengthMenu: 'Mostrar _MENU_ registros por pagina',
                  zeroRecords: 'No existen registros aun',
                  info: 'Mostrando pagina _PAGE_ de _PAGES_',
                  infoEmpty: 'No hay registros disponibles',
                  infoFiltered: '(filtrando de _MAX_ registros totales)',
                  filter: 'Buscar',
                }"
                :hover="true"
                :striped="true"
                :border="true"
                :small="small"
                :fixed="true"
                :items="rows"
                :fields="fields"
                :items-per-page="10"
                :dark="false"
                :sorter="false"
                :noItemsView="{ noItems: 'Sin resultados' }"
                pagination
                clickable-rows
                :loading="false"
              >
                <template #Cotización="{ item }">
                  <td>{{ item.NUM_COTIZACIÓN }}</td>
                </template>
                <template #Nombre_del_asegurado="{ item }">
                  <td>{{ item.NOM_SOLICITANTE }}</td>
                </template>
                <template #Prima="{ item }">
                  <td>${{ item.IMP_PRIMA_NETA }}</td>
                </template>
                <template #Vigencia="{ item }">
                  <td>{{ item.F_INI_VIGENCIA }}</td>
                </template>
                <template #Editar="{ item }">
                  <td class="text-center" style="width: 60px">
                    <router-link
                      :to="`/cotizador/vida?cotID=${item.ID_COTIZACION}&cotNum=${item.NUM_COTIZACIÓN}&linea=${item.ID_LIN_NEGOCIO}`"
                      class="btn btn-sm btn-warning"
                    >
                      <i class="fas fa-edit"></i>
                    </router-link>
                  </td>
                </template>
                <template #Pdf="{ item }">
                  <td class="text-center" style="width: 60px">
                    <button
                      @click="printPDF(item)"
                      class="btn btn-sm btn-outline-danger"
                    >
                      <i class="fas fa-file-pdf"></i>
                    </button>
                  </td>
                </template>
              </CDataTable>
            </div>
          </CCardHeader>
        </CCard>
      </CCol>
    </CCardGroup>
  </div>
</template>

<script>
import { format } from "../../../assets/helpers";

export default {
  data() {
    return {
      idAgente: 137, //localStorage.getItem("userId"),
      idEmpresa: 8,
      idProducto: null,
      idVersion: null,

      // Búsqueda
      busqueda: {
        numeroPoliza: null,
        fechaIni: null,
        fechaFin: null,
        tipo: null,
        sede: null,
        pNom_Solicitante: null,
      },

      // Search results
      rows: [],

      // Datatable
      small: Boolean,
      lang: String,
      fields: [
        "Cotización",
        "Nombre_del_asegurado",
        "Prima",
        "Vigencia",
        "Editar",
        "Pdf",
      ],
    };
  },
  methods: {
    async printPDF({ NUM_COTIZACIÓN, ID_AGP_TARIFA }) {
      const info = await this.getInfoProducto();
      const pdf = await this.getPdf(
        NUM_COTIZACIÓN,
        info.ID_PRODUCTO,
        ID_AGP_TARIFA
      );

      const pdfWindow = window.open("");
      if (!pdfWindow) {
        alert("Se ha bloqueado la nueva ventana");
      }
      pdfWindow.document.write(
        `<iframe width='100%' height='100%' src='data:application/pdf;base64, ${encodeURI(
          pdf.data
        )}'></iframe>`
      );
    },
    fillSearchFields(e, type = null) {
      if (type === "date") {
        this.busqueda[e.target.name] = format.date(e.target.value);
      } else {
        this.busqueda[e.target.name] = e.target.value;
      }
    },
    async search() {
      const { pNom_Solicitante, fechaIni, numeroPoliza } = this.busqueda;
      
      if (!pNom_Solicitante && !fechaIni && !numeroPoliza) {
        this.$swal("Error", "Por favor Ingresa al menos un filtro de búsqueda");
        return
      }


      const payload = {
        metodo: "BUSCACOTQA",
        data: {
          pNum_Poliza: this.busqueda.numeroPoliza || "-1",
          pF_Ini_Vigencia: this.busqueda.fechaIni || "-1",
          pRFC_Contratante: "-1",
          pNom_Solicitante: this.busqueda.pNom_Solicitante || "-1",
          pCve_T_Docto: "C",
          pId_Empresa: this.idEmpresa,
          pId_Agente: this.idAgente,
          pId_Lin_Negocio: "-1",
          pId_Producto: "1375",
          pId_UsuarioLogueado: this.idAgente,
        },
      };

      const response = await this.$store.dispatch("metodoPost", payload);
      if (response) {
        const results = await this.$store.getters.getRespuestaREST;

        this.rows = await results.map((result) => {
          if (result.IMP_PRIMA_NETA) {
            result.IMP_PRIMA_NETA = format.money(result.IMP_PRIMA_NETA);
          }

          if (result.F_INI_VIGENCIA) {
            result.F_INI_VIGENCIA = format.date(
              new Date(result.F_INI_VIGENCIA)
            );
          }
          return result;
        });
      }
    },
    async getInfo() {
      const payload = {
        metodo: "GET_INFO_PRODUCTO_CV",
        data: {
          pId_Empresa: this.idEmpresa,
          pId_Agente: this.idAgente,
        },
      };
      try {
        await this.$store.dispatch("metodoPost", payload);
        const res = await this.$store.getters.getRespuestaREST[0];
        this.idVersion = await res.ID_VERSION;
        this.idProducto = await res.ID_PRODUCTO;
      } catch (error) {
        console.log(error);
        alert("Lo sentimos, ocurrió un error");
      }
    },
    async getRows() {
      const payload = {
        metodo: "",
        data: {
          pNum_Poliza: "-1",
          pF_Ini_Vigencia: "-1",
          pRFC_Contratante: "-1",
          pNom_Solicitante: "-1",
          pCve_T_Docto: "C",
          pId_Empresa: this.idEmpresa,
          pId_Agente: this.idAgente,
          pId_Lin_Negocio: "-1",
          pId_Producto: this.idProducto,
          pId_UsuarioLogueado: this.idAgente,
        },
      };

      const response = await this.$store.dispatch("metodoPost", payload);
      console.log(response);
    },

    async getPdf(cotizacion, idProducto, pId_Agp_Tarifa) {
      const payload = {
        metodo: "GET_PDF_COTIZACION_QA",
        data: {
          pNum_Poliza: cotizacion,
          pId_Producto: idProducto,
          pId_Agente: this.idAgente,
          pId_Agp_Tarifa,
          pId_VersTr_AgpT: 0,
          pId_UsuarioLogueado: localStorage.getItem("userId"),
        },
      };

      await this.$store.dispatch("metodoPost", payload);
      return this.$store.getters.getRespuestaREST;
    },

    async getInfoProducto(idCotizacion) {
      const payload = {
        metodo: "GET_INFO_PRODUCTO_CV",
        data: { pId_Empresa: this.idEmpresa, pId_Agente: this.idAgente },
      };
      await this.$store.dispatch("metodoPost", payload);
      return this.$store.getters.getRespuestaREST[0];
    },
  },

  computed: {
    numberFormat(monto) {
      return format.money(monto);
    },
  },

  created() {
    this.getInfo();
  },
};
</script>
